import SupportDashboard from "@/pages/support/SupportDashboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/support/")({
  component: SupportDashboard,
});
